'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultOrder = {
  FIRST: 'asc',
  '': 'asc',
  asc: 'desc',
  desc: ''
};

exports.default = defaultOrder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sortabular/dist/default-order.js
// module id = 187
// module chunks = 0